import ApiService from '@/services/ApiService'

const REPOSITORY_URL = 'inventario_animal'

const InventarioRepository = {
  crearInventarioAnimal(idFichaGanadera, tipo, esCompleto, comentario, detalleInventario, fechaInventario){
    let data = {
      idFichaGanadera,
      tipo,
      esCompleto,
      comentario,
      detalleInventario,
      fechaInventario
    }
    return ApiService.post(`${REPOSITORY_URL}/crear`, data)
  },

  actualizarInventarioAnimal(idInventarioAnimal,esCompleto,comentario,detalleInventario){
    let data = {
      idInventarioAnimal,
      esCompleto,
      comentario,
      detalleInventario
    }
    return ApiService.post(`${REPOSITORY_URL}/actualizar`, data)
  },

  borrarInventarioAnimal(idInventarioAnimal){
    let data = {
      idInventarioAnimal
    }
    return ApiService.post(`${REPOSITORY_URL}/borrar`, data)
  },

  listaInventarioAnimal(idFichaGanadera){
    let data = {
      idFichaGanadera
    }
    return ApiService.get(`${REPOSITORY_URL}/lista_inventario`, data)
  },

  buscarInventarioAnimal(idInventarioAnimal){
    let data = {
      idInventarioAnimal
    }
    return ApiService.get(`${REPOSITORY_URL}/buscar_inventario`, data)
  },

  inventarioActualizado(idFichaGanadera,pAFecha){
    let data = {
      idFichaGanadera,
      pAFecha
    }
    return ApiService.get(`${REPOSITORY_URL}/inventario_actualizado`, data)
  },
  
  inventarioResultado(idFichaGanadera){
    let data = {
      idFichaGanadera
    }
    return ApiService.get(`${REPOSITORY_URL}/inventario_resultado`, data)
  }
}

export default InventarioRepository